export default __webpack_public_path__ + "static/media/apple.5bef35b8.png";